import { queryClient, useGet, usePost } from '@lovoldsystem/core.client'
import {
  IIdentityUserSyncApplyRequest,
  IIdentityUserSyncApplyResult,
  IIdentityUserSyncPreview,
} from 'src/types/identity-user-sync'
import { userQueryKey } from 'src/query-keys'

const baseUrl = () => 'admin/identity-user-sync'

export const identityUserSyncEndpoints = {
  preview: () => `${baseUrl()}/preview`,
  apply: () => `${baseUrl()}/apply`,
}

export const invalidateIdentityUserSyncPreview = () =>
  queryClient.invalidateQueries(userQueryKey.GET_IDENTITY_SYNC_PREVIEW())

export const useIdentitySyncPreview = (enabled: boolean) =>
  useGet<IIdentityUserSyncPreview>(identityUserSyncEndpoints.preview(), {}, {
    queryKey: userQueryKey.GET_IDENTITY_SYNC_PREVIEW(),
    enabled,
  })

export const useApplyIdentitySync = () =>
  usePost<IIdentityUserSyncApplyResult, IIdentityUserSyncApplyRequest>(identityUserSyncEndpoints.apply())
